/**
 * Expiration preset types
 */
export type ExpirationPresetType =
  | '1_day'
  | '1_week'
  | '1_month'
  | '3_months'
  | 'unlimited';

/**
 * Expiration preset options for select
 */
export const EXPIRATION_PRESET_OPTIONS = [
  { value: '1_day', label: '1日' },
  { value: '1_week', label: '1週間' },
  { value: '1_month', label: '1ヶ月' },
  { value: '3_months', label: '3ヶ月' },
  { value: 'unlimited', label: '無期限' },
] as const;

/**
 * Request body for POST /api/links
 */
export interface CreateLinkRequest {
  originalUrl: string;
  expiresPreset?: ExpirationPresetType | undefined;
  secretToken?: string | undefined;
}

/**
 * Link status
 */
export type LinkStatus = 'active' | 'paused' | 'expired';

/**
 * Response from POST /api/links
 */
export interface CreateLinkResponse {
  id: string;
  shortCode: string;
  shortUrl: string;
  originalUrl: string;
  status: LinkStatus;
  expiresAt: string | null;
  clickCount: number;
  createdAt: string;
  secretUrl: string;
  existingLink: boolean;
}

/**
 * API error response
 */
export interface ApiError {
  error: {
    code: string;
    message: string;
    field?: string;
  };
}

/**
 * Item in the list links response
 */
export interface ListLinksItem {
  id: string;
  shortCode: string;
  originalUrl: string;
  status: LinkStatus;
  clickCount: number;
  expiresAt: string | null;
  createdAt: string;
}

/**
 * Response from GET /api/manage/:secretToken
 */
export interface ListLinksResponse {
  items: ListLinksItem[];
  nextCursor: string | null;
  hasMore: boolean;
}

/**
 * Response from link action (pause/resume)
 */
export interface LinkActionResponse {
  id: string;
  status: LinkStatus;
  updatedAt: string;
}

/**
 * Device type for click tracking
 */
export type DeviceType = 'desktop' | 'mobile' | 'tablet';

/**
 * Single click detail item
 */
export interface ClickDetailItem {
  id: string;
  deviceType: DeviceType;
  os: string;
  browser: string;
  referer: string | null;
  occurredAt: string;
}

/**
 * Response from GET /api/manage/:secretToken/links/:id/clicks
 */
export interface GetClickDetailsResponse {
  items: ClickDetailItem[];
  nextCursor: string | null;
  hasMore: boolean;
}
